import React, { Component } from 'react';
import {
	Card,
	Row,
	Col,
	FormControl,
	FormLabel,
	CardGroup,
	Badge,
	FormGroup,
	ButtonGroup,
	Button,
} from 'react-bootstrap';
import Select from 'react-select';
import NumberFormat from 'react-number-format';
import SemaforoFormatter from '../SalesFrequency/SemaforoFormatter';
import ReactTooltip from 'react-tooltip';
import { toast } from 'react-toastify';
import {
	Accordion as PrimeAccordion,
	AccordionTab,
} from 'primereact/accordion';
import _ from 'lodash';
import ptBR from 'date-fns/locale/pt-BR';
import DatePicker, { registerLocale } from 'react-datepicker';
import Spinner from '@atlaskit/spinner';

import selectStyles from '../../components/DropDown/selectStyles';
import CursorInput from '../../components/CursorInput';
import dateFormat from '../../utils/date';
import { getMessageFromRequest } from '../../utils/errors';
import Popout from '../../components/Popout';
import Search from '../../components/Search';
import LoadingButton from '../../components/LoadingButton';
import { withUser } from '../../modules/User';
import api from '../../api';

import './styles.scss';

/*
  <Customers
    clientes={clientes}
    clienteAtual={clienteAtual}
    pedidosCliente={pedidosCliente}
    representantesCliente={representantesCliente}
    pedidoAtual={pedidoAtual}
    currentIndex={currentIndex}
    handleNext={this.handleNext}
    handlePrevious={this.handlePrevious}
    handleClienteSelectChange={this.handleClienteSelectChange}
  />
*/

registerLocale('ptBR', ptBR);

const defaultButtonStyle = {
	width: '100%',
};

const repClienteToOptions = (representante) => ({
	label: representante,
	value: representante,
});

const cityToOptions = ({ code, name, stateCode }) => ({
	label: `${code} - ${name} - ${stateCode}`,
	value: code,
});

const clienteToOptions = ({ name, register, ...rest }, index) => ({
	name: name,
	register: register,
	label: `${register} - ${name}`,
	value: `${register} - ${name}`,
	index,
	...rest,
});

const customerToOptions = ({ register, name }) => ({
	label: `${register} - ${name}`,
	value: register,
});

const getValueFromOption = ({ value }) => value;

const getFirstDay = (date) => {
	var newDate = new Date(date);
	var firstDay = new Date(newDate.getFullYear(), newDate.getMonth(), 1);
	return firstDay;
};

const getLastDay = (date) => {
	var newDate = new Date(date);
	var lastDay = new Date(newDate.getFullYear(), newDate.getMonth() + 1, 0);
	return lastDay;
};

const dateFixed = (date) => new Date(date).toISOString().split('T')[0];

const selectField = {
	...selectStyles,
	control: (provided) => ({
		...provided,
		minWidth: 100,
		minHeight: 15,
		padding: 0,
	}),
	menu: (provided) => ({
		...provided,
		paddingTop: 0,
	}),
};

const INITIAL_STATE = {
	// customers
	clientes: [],
	clienteAtual: undefined,
	pedidosCliente: [],
	representantesCliente: [],
	pedidoAtual: undefined,
	customerRoute: '',
	routeEdited: false,

	// Filters
	// representante: '', // removido para não limpar representante ao rodar handleCLear
	searchedRepresentante: '',
	searchedCidade: [],
	searchedCliente: [],
	// searchedSupervisor: [],
	// suggestionPriority: '',
	route: '',
	bought: false,
	requestDate: getFirstDay(Date.now()),
	requestDateFinal: getLastDay(Date.now()),

	// Page State
	isLoading: false,
	isSending: false,
	currentIndex: 0,
	activeIndex: 0,
};

class Customers extends Component {
	state = {
		...INITIAL_STATE,
		representante: this.props.userProps
			? this.props.userProps.representativeId
			: '',
	};

	// Lifecycle
	componentDidUpdate() {
		// Quando já está logado, ao entrar na pg a request de usuário ainda não vai ter retornado o ID do representante
		// Então, é necessário rodar um spinner (está lá no render) até que tenha um objeto de user
		// Quando entrar o objeto de user, o componentDidUpdate dispara e verifica se chego
		// Caso sim, verifica se existe repId ou se é igual a 0 E, se o representante no estado está vazio e é diferente de 0 (isso é importante para evitar loop de renderização)
		// E então, seta o representante no estado
		if (this.props.userProps) {
			const { representativeId } = this.props.userProps;
			if (
				(representativeId || representativeId === 0) &&
				!this.state.representante &&
				this.state.representante !== 0
			) {
				this.setState({ representante: representativeId });
			}
		}
	}

	// Handlers

	handleActiveIndex = (activeIndex) => this.setState({ activeIndex });

	/*
	 * Uma função para mudança de estado para todos
	 * os campos "Input" da tela, para melhorar a
	 * visualização do código.
	 */
	handleFieldChange = (e) => this.setState({ [e.target.name]: e.target.value });

	handleRouteChange = (e) =>
		this.setState({ [e.target.name]: e.target.value, routeEdited: true });

	/*
	 * Uma função para mudança de estado para todos
	 * os campos "Date" da tela, para melhorar a
	 * visualização do código.
	 */
	handleDateChange = (name, value) => this.setState({ [name]: value });

	handleRequestDate = (requestDate) =>
		this.setState({ requestDate: getFirstDay(requestDate) });

	handleRequestDateFinal = (requestDateFinal) =>
		this.setState({ requestDateFinal: getLastDay(requestDateFinal) });

	handleSearchedCidade = (searchedCidade) => this.setState({ searchedCidade });

	handleSearchedCliente = (searchedCliente) =>
		this.setState({ searchedCliente });

	handleSearchedSupervisor = (searchedSupervisor) =>
		this.setState({ searchedSupervisor });

	handleArticle = (articlesSelected) => this.setState({ articlesSelected });

	handleClear = () =>
		this.setState({
			...INITIAL_STATE,
			tabAtual: this.state.tabAtual,
			articlesOptions: this.state.articlesOptions,
			articlesSelected: this.state.articlesOptions,
		});

	// Request

	handleNext = () =>
		this.setState((state) => {
			toast.dismiss();
			const { currentIndex, pedidosCliente } = state;
			const nextIndex = currentIndex + 1;
			return {
				...state,
				currentIndex:
					nextIndex < pedidosCliente.length ? nextIndex : currentIndex,
				pedidoAtual:
					nextIndex < pedidosCliente.length
						? pedidosCliente[nextIndex]
						: pedidosCliente[currentIndex],
			};
		});

	handlePrevious = () =>
		this.setState((state) => {
			toast.dismiss();
			const { currentIndex, pedidosCliente } = state;
			const newIndex = currentIndex > 0 ? currentIndex - 1 : currentIndex;
			return {
				...state,
				currentIndex: newIndex,
				pedidoAtual: pedidosCliente[newIndex],
			};
		});

	handleSave = async () => {
		this.setState({ isSaving: true });

		const { clienteAtual, customerRoute, clientes } = this.state;

		const customer = {
			...clienteAtual,
			route: customerRoute ? parseInt(customerRoute) : 0,
		};

		try {
			await api.comercial.customer.updateCustomer(customer);

			const clienteEditado = clientes.find((x) => x.name === clienteAtual.name);
			clienteEditado.route = customerRoute;

			this.setState({
				routeEdited: false,
				clientes: [...clientes, (clienteEditado.route = customerRoute)],
			});
		} catch (err) {
			toast.error(`Erro ao salvar: ${err.message}`);
		} finally {
			this.setState({ isSaving: false });
		}
	};

	handleClienteSelectChange = (option) => {
		this.setState(() => {
			const pedidosCliente = option ? option.orders : [];
			const pedidoAtual = pedidosCliente[0];

			if (!option) return;

			const clienteRep = option.representative
				? repClienteToOptions(option.representative)
				: '';

			const clienteReps =
				option.representatives.length > 0
					? option.representatives.map(repClienteToOptions)
					: '';

			const representantes = [
				...new Map(
					[clienteRep, ...clienteReps].map((item) => [item['label'], item]),
				).values(),
			];

			return {
				clienteAtual: option,
				pedidosCliente,
				pedidoAtual,
				currentIndex: 0,
				representantesCliente: representantes,
				customerRoute: option.route,
			};
		});
	};

	handleConsultarPedidos = async () => {
		const {
			representante,
			searchedCidade,
			searchedCliente,
			searchedRepresentante,
			route,
			// suggestionPriority,
			requestDate,
			requestDateFinal,
		} = this.state;

		const rep = representante === 0 ? searchedRepresentante : representante;

		const params = {
			initialIssueDate: dateFixed(requestDate),
			finalIssueDate: dateFixed(requestDateFinal),
			representativeId: rep !== 0 ? rep : null,
			route: route,
			// suggestionPriority: suggestionPriority,
			cities: searchedCidade.map(getValueFromOption).toString(),
			customers: searchedCliente.map(getValueFromOption).toString(),
		};
		this.setState({
			isLoading: true,
			clientes: [],
			clienteAtual: undefined,
			pedidosCliente: [],
			pedidoAtual: undefined,
		});
		try {
			const { data } = await api.comercial.customer.getCustomerOrders({
				params: params,
			});

			if (data.length === 0) {
				toast.warn('Nenhum cliente encontrado!');
				return;
			}
			const clientes = data.map((cliente, index) =>
				clienteToOptions(cliente, index),
			);

			const clienteAtual = clientes ? clientes[0] : undefined;
			const customerRoute = clientes ? clientes[0].route : undefined;
			this.setState({ clientes, customerRoute }, () => {
				if (clientes) this.handleClienteSelectChange(clienteAtual);
			});
		} catch (err) {
			toast.error(`Erro ao consultar Clientes: ${err.message}`);
		} finally {
			this.setState({ isLoading: false, activeIndex: null });
		}
	};

	// Loads

	loadCities = _.debounce(
		(inputValue, callback) => {
			api.comercial.filters.city
				.search(inputValue)
				.then(({ data: searchOptions }) => {
					const result = searchOptions.map(cityToOptions);
					callback(result);
				})
				.catch((err) => {
					const message = getMessageFromRequest(err);
					toast.error(message);
				});
		},
		700,
		{ trailing: true, leading: false },
	);

	loadCustomers = _.debounce(
		(inputValue, callback) => {
			api.comercial.filters.customer
				.search(inputValue)
				.then(({ data: searchOptions }) => {
					const result = searchOptions.map(customerToOptions);
					callback(result);
				})
				.catch((err) => {
					const message = getMessageFromRequest(err);
					toast.error(message);
				});
		},
		700,
		{ trailing: true, leading: false },
	);

	render() {
		const {
			// Customers
			clientes,
			clienteAtual,
			pedidosCliente,
			representantesCliente,
			pedidoAtual,
			customerRoute,
			routeEdited,

			// Filters
			representante,
			searchedRepresentante,
			searchedCidade,
			searchedCliente,
			// searchedSupervisor,
			// suggestionPriority,
			route,
			requestDate,
			requestDateFinal,

			// Page State
			isLoading,
			isSaving,
			// isSending,
			currentIndex,
			activeIndex,
		} = this.state;

		const cliente = clienteAtual ? clienteAtual : undefined;
		const ultimaCompraCor = cliente
			? cliente.lastPurchaseDate
				? cliente.daysSinceLastPurchase < 180
					? '#39cd33'
					: '#eae825'
				: '#ff491c'
			: '#2a2c2d';
		const corAtraso = cliente
			? cliente.overdueTitles > 0
				? '#ff491c'
				: '#2a2c2d'
			: '#2a2c2d';

		if (representante === '')
			return (
				<div
					style={{
						display: 'flex',
						width: '100%',
						height: '100%',
						alignItems: 'center',
						justifyContent: 'center',
					}}
				>
					<Spinner size="xlarge" />
				</div>
			);

		return (
			<>
				<div>
					<PrimeAccordion
						activeIndex={activeIndex}
						onTabChange={(e) => this.handleActiveIndex(e.index)}
						style={{ marginBottom: '0.8vh' }}
					>
						<AccordionTab header="Filtros">
							<Row>
								{representante === 0 && (
									<Col md={3}>
										<FormGroup>
											<FormLabel>Representante</FormLabel>
											<FormControl
												style={{ marginBottom: '20px' }}
												className="rounded-input"
												type="text"
												name="searchedRepresentante"
												value={searchedRepresentante}
												onChange={this.handleFieldChange}
												disabled={representante !== 0}
											/>
										</FormGroup>
									</Col>
								)}
								{
									<Col md={3}>
										<FormGroup>
											<FormLabel>Cidade</FormLabel>
											<Popout
												buttonStyle={defaultButtonStyle}
												title="Selecione um(a)"
												isMulti
												loadOptions={this.loadCities}
												onChange={this.handleSearchedCidade}
												value={searchedCidade}
												Component={Search}
												maxDisplay={1}
												disabled={!representante}
												menuWidth={'100%'}
											/>
										</FormGroup>
									</Col>
								}
								{
									<Col md={3}>
										<FormGroup>
											<FormLabel>Cliente</FormLabel>
											<Popout
												buttonStyle={defaultButtonStyle}
												title="Selecione um(a)"
												isMulti
												loadOptions={this.loadCustomers}
												onChange={this.handleSearchedCliente}
												value={searchedCliente}
												Component={Search}
												maxDisplay={1}
												disabled={!representante}
												menuWidth={'100%'}
											/>
										</FormGroup>
									</Col>
								}
								{
									<Col md={1}>
										<FormGroup>
											<FormLabel style={{ marginBottom: '11px' }}>
												Rota
											</FormLabel>
											<FormControl
												className="rounded-input"
												name="route"
												value={route}
												onChange={this.handleFieldChange}
											/>
										</FormGroup>
									</Col>
								}
								{
									<Col md={3}>
										<FormGroup>
											<FormLabel>Emissão</FormLabel>
											<div className="date-filter d-flex justify-content-between">
												<DatePicker
													className="form-control rounded-input"
													selected={requestDate}
													selectsStart
													locale="ptBR"
													startDate={requestDate}
													onChange={this.handleRequestDate}
													dateFormat="MM/yyyy"
													showMonthYearPicker
												/>
												<i className="fa fa-arrow-right fa-md mt-2" />
												<DatePicker
													className="form-control rounded-input"
													selected={requestDateFinal}
													selectsStart
													locale="ptBR"
													startDate={requestDateFinal}
													onChange={this.handleRequestDateFinal}
													dateFormat="MM/yyyy"
													showMonthYearPicker
												/>
											</div>
										</FormGroup>
									</Col>
								}
								<Col md={3}>
									<div className="actions">
										<FormGroup style={{ marginTop: '29px' }}>
											<ButtonGroup>
												{
													<LoadingButton
														type="button"
														variant="success"
														title="Consultar"
														onClick={this.handleConsultarPedidos}
														isLoading={isLoading}
													>
														{Button}
													</LoadingButton>
												}
												{
													<Button
														className="btn btn-secondary"
														onClick={this.handleClear}
													>
														Limpar
													</Button>
												}
											</ButtonGroup>
										</FormGroup>
									</div>
								</Col>
							</Row>
						</AccordionTab>
					</PrimeAccordion>
				</div>
				<Card className="clientes-container">
					<Card.Body className="align-items-center">
						<LoadingButton
							icon="fa fa-save"
							type="button"
							variant="success"
							title="Salvar"
							onClick={this.handleSave}
							isLoading={isSaving}
							disabled={!routeEdited}
							style={{ marginBottom: '10px' }}
						>
							{Button}
						</LoadingButton>
						<CardGroup className="clientes-card">
							<Card>
								<Card.Header>
									<FormLabel>Cliente Atual</FormLabel>
									<Select
										placeholder="Selecione um cliente..."
										noOptionsMessage={() => 'Nenhuma opção encontrada.'}
										styles={selectStyles}
										name="clienteAtual"
										value={clienteAtual}
										options={clientes}
										onChange={(option) =>
											this.handleClienteSelectChange(option)
										}
									/>
								</Card.Header>
								<Card.Body>
									<Row>
										<Col md={6}>
											<FormLabel className="mt-2">Endereço</FormLabel>
											<FormControl
												value={
													cliente
														? cliente.address
															? cliente.address
															: 'Sem informação'
														: 'Sem informação'
												}
												readOnly
											/>
										</Col>
										<Col md={4}>
											<FormLabel className="mt-2">Cidade</FormLabel>
											<FormControl
												value={
													cliente
														? cliente.city
															? cliente.city
															: 'Sem informação'
														: 'Sem informação'
												}
												readOnly
											/>
										</Col>
										<Col md={2}>
											<FormLabel className="mt-2">Estado</FormLabel>
											<FormControl
												value={
													cliente
														? cliente.state
															? cliente.state
															: 'Sem informação'
														: 'Sem informação'
												}
												readOnly
											/>
										</Col>
									</Row>
									<Row>
										<Col md={3} xs={3}>
											<FormLabel className="mt-2">CEP</FormLabel>
											<FormControl
												value={
													cliente
														? cliente.zipCode
															? cliente.zipCode
															: 'Sem informação'
														: 'Sem informação'
												}
												readOnly
											/>
										</Col>
										<Col md={3} xs={3}>
											<FormLabel className="mt-2">Telefone</FormLabel>
											<FormControl
												value={
													cliente
														? cliente.telephone
															? cliente.telephone
															: 'Sem informação'
														: 'Sem informação'
												}
												readOnly
											/>
										</Col>
										<Col md={3} xs={3}>
											<FormLabel className="mt-2">Celular</FormLabel>
											<FormControl
												value={
													cliente
														? cliente.cellphone
															? cliente.cellphone
															: 'Sem informação'
														: 'Sem informação'
												}
												readOnly
											/>
										</Col>
										<Col md={3} xs={3}>
											<FormLabel className="mt-2">
												Whats <i className="fa fa-whatsapp" />
											</FormLabel>
											<FormControl
												value={
													cliente
														? cliente.whats
															? cliente.whats
															: 'Sem informação'
														: 'Sem informação'
												}
												readOnly
											/>
										</Col>
									</Row>
									<Row>
										<Col md={6} xs={6}>
											<FormLabel className="mt-2">Email</FormLabel>
											<FormControl
												value={
													cliente
														? cliente.email
															? cliente.email
															: 'Sem informação'
														: 'Sem informação'
												}
												readOnly
											/>
										</Col>
										<Col md={3} xs={3}>
											<FormLabel className="mt-2">Insc. Estadual</FormLabel>
											<FormControl
												value={
													cliente
														? cliente.stateRegistration
															? cliente.stateRegistration
															: 'Sem informação'
														: 'Sem informação'
												}
												readOnly
											/>
										</Col>
										<Col md={3} xs={3}>
											<FormLabel className="mt-2">Suframa</FormLabel>
											<FormControl
												value={
													cliente
														? cliente.suframa
															? cliente.suframa
															: 'Sem informação'
														: 'Sem informação'
												}
												readOnly
											/>
										</Col>
									</Row>
									<Row>
										<Col md={3} xs={3}>
											<FormLabel className="mt-2">Cadastro</FormLabel>
											<DatePicker
												placeholderText="Sem informação"
												className="form-control rounded-input"
												selected={
													cliente
														? cliente.registrationDate
															? new Date(
																	dateFormat(
																		cliente.registrationDate,
																		'YYYY/MM/DD',
																	),
															  )
															: ''
														: ''
												}
												locale="pt-BR"
												dateFormat="dd/MM/yyyy"
												readOnly
											/>
										</Col>
										<Col md={3} xs={3}>
											<FormLabel
												className="mt-2"
												style={{ color: ultimaCompraCor }}
											>
												Última Compra
											</FormLabel>
											<DatePicker
												placeholderText="Sem informação"
												className="form-control rounded-input"
												selected={
													cliente
														? cliente.lastPurchaseDate
															? new Date(
																	dateFormat(
																		cliente.lastPurchaseDate,
																		'YYYY/MM/DD',
																	),
															  )
															: ''
														: ''
												}
												locale="pt-BR"
												dateFormat="dd/MM/yyyy"
												readOnly
											/>
										</Col>
										<Col md={6} xs={6}>
											<FormLabel className="mt-2">Grupo Econômico</FormLabel>
											<FormControl
												value={
													cliente
														? cliente.economicGroup
															? cliente.economicGroup
															: 'Sem informação'
														: 'Sem informação'
												}
												readOnly
											/>
										</Col>
									</Row>
									<Row>
										<Col md={6} xs={6}>
											<FormLabel className="mt-2">
												Coleção Últ. Compra
											</FormLabel>
											<FormControl
												value={
													cliente
														? cliente.lastPurchaseCollection
															? cliente.lastPurchaseCollection
															: 'Sem informação'
														: 'Sem informação'
												}
												readOnly
											/>
										</Col>
										<Col md={6} xs={6}>
											<FormLabel className="mt-2">
												Representante(s) Cliente
											</FormLabel>
											<Select
												placeholder="Nenhum representate..."
												noOptionsMessage={() => 'Nenhuma opção encontrada.'}
												styles={selectField}
												value={representantesCliente[0]}
												options={representantesCliente}
											/>
										</Col>
									</Row>
									<Row>
										<Col md={1} xs={1}>
											<FormLabel style={{ marginBottom: '11px' }}>
												Rota
											</FormLabel>
											<FormControl
												className="rounded-input"
												name="customerRoute"
												value={customerRoute}
												onChange={this.handleRouteChange}
												readOnly={cliente ? false : true}
												placeholder="Sem informação"
											/>
										</Col>
										<Col md={2} xs={2}>
											<FormLabel className="mt-2">Sem. Fin.</FormLabel>
											<SemaforoFormatter
												isLimitless
												value={cliente ? cliente.financialFlag : '5'}
												size={20}
											/>
											<ReactTooltip class="toolTip" />
										</Col>
										<Col md={3} xs={3}>
											<FormLabel className="mt-2">Lim. Crédito</FormLabel>
											<NumberFormat
												className="form-control"
												decimalScale={2}
												thousandSeparator="."
												decimalSeparator=","
												prefix={'R$'}
												fixedDecimalScale
												readOnly
												value={cliente ? cliente.creditLimit : 0}
											/>
										</Col>
										<Col md={3} xs={3}>
											<FormLabel className="mt-2">Saldo Limite</FormLabel>
											<NumberFormat
												className="form-control"
												decimalScale={2}
												thousandSeparator="."
												decimalSeparator=","
												prefix={'R$'}
												fixedDecimalScale
												readOnly
												value={cliente ? cliente.balanceLimit : 0}
											/>
										</Col>
										<Col md={3} xs={3}>
											<FormLabel className="mt-2">Saldo Projetado</FormLabel>
											<NumberFormat
												className="form-control"
												decimalScale={2}
												thousandSeparator="."
												decimalSeparator=","
												prefix={'R$'}
												fixedDecimalScale
												readOnly
												value={cliente ? cliente.salePotential : 0}
											/>
										</Col>
									</Row>
									<Row>
										<Col md={2} xs={2}>
											<FormLabel className="mt-2">Desconto</FormLabel>
											<FormControl
												value={
													cliente
														? `${cliente.averageDiscount}%`
														: 'Sem informação'
												}
												readOnly
											/>
										</Col>
										<Col md={2} xs={2}>
											<FormLabel className="mt-2">Prazo</FormLabel>
											<FormControl
												value={
													cliente ? cliente.averageDeadline : 'Sem informação'
												}
												readOnly
											/>
										</Col>
										<Col md={2} xs={2}>
											<FormLabel className="mt-2">Maior Atraso</FormLabel>
											<FormControl
												value={
													cliente ? cliente.daysGreatestDelay : 'Sem informação'
												}
												readOnly
											/>
										</Col>
										<Col md={3} xs={3}>
											<FormLabel className="mt-2">Títulos em Aberto</FormLabel>
											<NumberFormat
												className="form-control"
												decimalScale={2}
												thousandSeparator="."
												decimalSeparator=","
												prefix={'R$'}
												fixedDecimalScale
												readOnly
												value={cliente ? cliente.openTitles : 0}
											/>
										</Col>
										<Col md={3} xs={3}>
											<FormLabel className="mt-2" style={{ color: corAtraso }}>
												Títulos em Atraso
											</FormLabel>
											<NumberFormat
												className="form-control"
												decimalScale={2}
												thousandSeparator="."
												decimalSeparator=","
												prefix={'R$'}
												fixedDecimalScale
												readOnly
												value={cliente ? cliente.overdueTitles : 0}
											/>
										</Col>
									</Row>
								</Card.Body>
							</Card>
							<Card>
								<Card.Header>
									<FormLabel>Pedido Atual</FormLabel>
									<Badge
										variant={pedidoAtual ? pedidoAtual.statusColor : 'dark'}
										style={{
											marginLeft: '10px',
											paddingTop: '8px',
											paddingLeft: '10px',
											paddingRight: '10px',
											marginRight: '10px',
										}}
									>
										{' '}
									</Badge>
									<CursorInput
										getRef={this.opRef}
										id="pedidos-cliente"
										className="form-control"
										type="text"
										placeholder="Sem informação"
										onChange={() => {}}
										onKeyDown={() => {}}
										onClear={() => {}}
										onNext={this.handleNext}
										onPrevious={this.handlePrevious}
										disablePrevious={currentIndex === 0}
										disableNext={currentIndex === pedidosCliente.length - 1}
										value={
											(pedidosCliente &&
												pedidosCliente[currentIndex] &&
												pedidosCliente[currentIndex].order) ||
											''
										}
										autoComplete="off"
										readOnly
										showCursors={pedidosCliente.length > 1}
									/>
								</Card.Header>
								<Card.Body>
									<Row>
										<Col md={6} xs={6}>
											<FormLabel className="mt-2">Data de Emissão</FormLabel>
											<FormControl
												value={
													pedidoAtual
														? dateFormat(pedidoAtual.issueDate, 'DD/MM/YYYY')
														: 'Sem informação'
												}
												readOnly
											/>
										</Col>
										<Col md={6} xs={6}>
											<FormLabel className="mt-2">Quantidade</FormLabel>
											<FormControl
												value={
													pedidoAtual
														? pedidoAtual.totalAmount
														: 'Sem informação'
												}
												readOnly
											/>
										</Col>
									</Row>
									<Row>
										<Col md={6} xs={6}>
											<FormLabel className="mt-2">Valor Total</FormLabel>
											<NumberFormat
												className="form-control"
												decimalScale={2}
												thousandSeparator="."
												decimalSeparator=","
												prefix={'R$'}
												fixedDecimalScale
												readOnly
												value={pedidoAtual ? pedidoAtual.totalValue : 0}
											/>
										</Col>
										<Col md={6} xs={6}>
											<FormLabel className="mt-2">
												Valor Líquido Total
											</FormLabel>
											<NumberFormat
												className="form-control"
												decimalScale={2}
												thousandSeparator="."
												decimalSeparator=","
												prefix={'R$'}
												fixedDecimalScale
												readOnly
												value={pedidoAtual ? pedidoAtual.totalNetValue : 0}
											/>
										</Col>
									</Row>
									<FormLabel className="mt-2">Tabela de Preço</FormLabel>
									<FormControl
										value={
											pedidoAtual ? pedidoAtual.priceTable : 'Sem informação'
										}
										readOnly
									/>
									<FormLabel className="mt-2">Representante Pedido</FormLabel>
									<FormControl
										value={
											pedidoAtual
												? pedidoAtual.representative
												: 'Sem informação'
										}
										readOnly
									/>
									<Row>
										<Col md={3} xs={3}>
											<FormLabel className="mt-2">Nota Fiscal</FormLabel>
											<FormControl
												value={
													pedidoAtual ? pedidoAtual.invoice : 'Sem informação'
												}
												readOnly
											/>
										</Col>
										<Col md={3} xs={3}>
											<FormLabel className="mt-2">Valor Faturado</FormLabel>
											<NumberFormat
												className="form-control"
												decimalScale={2}
												thousandSeparator="."
												decimalSeparator=","
												prefix={'R$'}
												fixedDecimalScale
												readOnly
												value={pedidoAtual ? pedidoAtual.invoicedAmount : 0}
											/>
										</Col>
										<Col md={6} xs={6}>
											<FormLabel className="mt-2">
												Data de Emissão da Nota
											</FormLabel>
											<FormControl
												value={
													pedidoAtual
														? dateFormat(
																pedidoAtual.invoiceIssueDate,
																'DD/MM/YYYY',
														  )
														: 'Sem informação'
												}
												readOnly
											/>
										</Col>
									</Row>
									<FormLabel className="mt-2">Transportadora</FormLabel>
									<FormControl
										value={
											pedidoAtual
												? pedidoAtual.shippingCompany
												: 'Sem informação'
										}
										readOnly
									/>
								</Card.Body>
							</Card>
						</CardGroup>
					</Card.Body>
				</Card>
			</>
		);
	}
}

export default withUser(Customers);
